/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import * as models from '@api';
import { PurchaseItem } from 'src/js/model/index';
import { inspect } from 'util';
import { Actions, requestCourseClass, requestProduct } from '../../web/actions/Actions';

export class ContactNodeService {
  /**
   * Extracts correspondent item from the node and cast to corespondent type.
   * We do it to get an possibility to use 'instanceof' expression for purchase items.
   * className can accept the following values:
   */
  static getPurchaseItem = (node: models.ContactNode, original: any): PurchaseItem => {

    if (original instanceof models.Application) {
      return Object.assign(new models.Application(), node.applications[0]);
    }

    if (original instanceof models.Article) {
      return Object.assign(new models.Article(), node.articles[0]);
    }

    if (original instanceof models.Enrolment) {
      return Object.assign(new models.Enrolment(), node.enrolments[0]);
    }

    if (original instanceof models.Membership) {
      return Object.assign(new models.Membership(), node.memberships[0]);
    }

    if (original instanceof models.Voucher) {
      return Object.assign(new models.Voucher(), node.vouchers[0]);
    }

    if (original instanceof models.WaitingList) {
      return Object.assign(new models.WaitingList(), node.waitingLists[0]);
    }

    throw new Error(`Unsupported purchase item: ${inspect(original, true, 10, true)}`);
  };

  static getRelationsUpdateActions = (nodes: models.ContactNode[]) => {
    const actions = [];
    nodes.forEach(node => {
      if (node.articles.length) {
        node.articles.forEach(article => {
          if (article.relatedClassId || article.relatedProductId) {
            actions.push(requestProduct({ id: article.productId }));
          }
        });
      }
      if (node.vouchers.length) {
        node.vouchers.forEach(voucher => {
          if (voucher.relatedClassId || voucher.relatedProductId) {
            actions.push(requestProduct({ id: voucher.productId }));
          }
        });
      }
      if (node.memberships.length) {
        node.memberships.forEach(membership => {
          if (membership.relatedClassId || membership.relatedProductId) {
            actions.push(requestProduct({ id: membership.productId }));
          }
        });
      }
      if (node.enrolments.length) {
        node.enrolments.forEach(enrolment => {
          if (enrolment.relatedClassId || enrolment.relatedProductId) {
            if (!enrolment.classId) {
              actions.push({
                type: Actions.REQUEST_INACTIVE_COURSE,
                payload: enrolment.courseId,
              });
            } else {
              actions.push(requestCourseClass({ id: enrolment.classId }));
            }
          }
        });
      }
    });
    return actions;
  };
}
